import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  Button,
  Create,
  Form,
  SelectInput,
  TextInput,
  useNotify,
} from "react-admin";
import { Cancel, Save } from "@mui/icons-material";
import PropTypes from "prop-types";
import { createNewLead } from "../../Utils/RestUtils";
import { useSearchParams } from "react-router-dom";
import { getDuplicatesByReg } from "../../Utils/QuoteRequestUtils";

const CreateQuoteRequest = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [duplicates, setDuplicates] = useState(null);
  const notify = useNotify();

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const stateAbbreviations = [
    { label: "AL", value: "AL" },
    { label: "AK", value: "AK" },
    { label: "AZ", value: "AZ" },
    { label: "AR", value: "AR" },
    { label: "CA", value: "CA" },
    { label: "CO", value: "CO" },
    { label: "CT", value: "CT" },
    { label: "DE", value: "DE" },
    { label: "FL", value: "FL" },
    { label: "GA", value: "GA" },
    { label: "HI", value: "HI" },
    { label: "ID", value: "ID" },
    { label: "IL", value: "IL" },
    { label: "IN", value: "IN" },
    { label: "IA", value: "IA" },
    { label: "KS", value: "KS" },
    { label: "KY", value: "KY" },
    { label: "LA", value: "LA" },
    { label: "ME", value: "ME" },
    { label: "MD", value: "MD" },
    { label: "MA", value: "MA" },
    { label: "MI", value: "MI" },
    { label: "MN", value: "MN" },
    { label: "MS", value: "MS" },
    { label: "MO", value: "MO" },
    { label: "MT", value: "MT" },
    { label: "NE", value: "NE" },
    { label: "NV", value: "NV" },
    { label: "NH", value: "NH" },
    { label: "NJ", value: "NJ" },
    { label: "NM", value: "NM" },
    { label: "NY", value: "NY" },
    { label: "NC", value: "NC" },
    { label: "ND", value: "ND" },
    { label: "OH", value: "OH" },
    { label: "OK", value: "OK" },
    { label: "OR", value: "OR" },
    { label: "PA", value: "PA" },
    { label: "RI", value: "RI" },
    { label: "SC", value: "SC" },
    { label: "SD", value: "SD" },
    { label: "TN", value: "TN" },
    { label: "TX", value: "TX" },
    { label: "UT", value: "UT" },
    { label: "VT", value: "VT" },
    { label: "VA", value: "VA" },
    { label: "WA", value: "WA" },
    { label: "WV", value: "WV" },
    { label: "WI", value: "WI" },
    { label: "WY", value: "WY" },
  ];

  const leadSources = [
    {
      number: "01243201010",
      name: "Scrap Car Comparison - Main",
    },
    {
      number: "441243201010",
      name: "Scrap Car Comparison - Main",
    },
    {
      number: "01243219178",
      name: "Scrap Car Comparison - Facebook",
    },
    {
      number: "441243219178",
      name: "Scrap Car Comparison - Facebook",
    },
    {
      number: "01243974692",
      name: "National Scrap Car - Main",
    },
    {
      number: "441243974692",
      name: "National Scrap Car - Main",
    },
    {
      number: "01243219177",
      name: "National Scrap Car - Adwords",
    },
    {
      number: "441243219177",
      name: "National Scrap Car - Adwords",
    },
    {
      number: "02380008800",
      name: "BMS Salvage - Main",
    },
    {
      number: "442380008800",
      name: "BMS Salvage - Main",
    },
    {
      number: "01243201011",
      name: "BMS Cars - Workshop",
    },
    {
      number: "441243201011",
      name: "BMS Cars - Workshop",
    },
    {
      number: "01243202015",
      name: "BMS Cars - Sales",
    },
    {
      number: "441243202015",
      name: "BMS Cars - Sales",
    },
    {
      number: "01243202012",
      name: "Shore Cars - Main",
    },
    {
      number: "441243202012",
      name: "Shore Cars - Main",
    },
    {
      number: "02380001801",
      name: "Scrap Cars For Cash - Main",
    },
    {
      number: "442380001801",
      name: "Scrap Cars For Cash - Main",
    },
  ];

  const handleSubmit = async (values) => {
    let results = [];
    setIsLoading(true);

    for (var i = 0; i < leadSources.length; i++) {
      if (leadSources[i].number === values.dialled) {
        results.push(leadSources[i]);
      }
    }

    if (!values.vin && !values.plate) {
      notify("Please enter a Plate or VIN.", {
        type: "error",
      });
      setIsLoading(null);
      return;
    }

    if (values.plate && !values.state) {
      notify("Please select a State.", {
        type: "error",
      });
      setIsLoading(null);
      return;
    }

    const result = await createNewLead({
      zipcode: values.zipcode,
      vin: values.vin || undefined,
      plate: values.plate ? values.plate.toUpperCase() : undefined,
      state: values.state,
      lead_source: results.length > 0 ? results[0].name : "Calls in",
      referring_url: "manual",
    });

    if (result.result === "success") {
      if (result.dvla === "failure") {
        setIsLoading(false);

        notify(
          "There was a problem adding a new lead - " +
            result.error +
            " - Double check the reg with the customer, otherwise please speak to your line manager",
          {
            type: "error",
          }
        );
      } else {
        location.href =
          "/#/quote-requests/%2Fapi%2Fquote-requests%2F" + result.lead_id;
      }
    } else {
      setIsLoading(false);

      notify("There was a problem adding a new lead - " + result.error, {
        type: "error",
      });
    }
  };

  const handleDuplicateCheck = async (type, value) => {
    try {
      const duplicatesData = await getDuplicatesByReg({
        type,
        vinNumber: type === "vin" ? value : null,
        registration:
          type === "plate" ? value.toUpperCase().replace(/\s/g, "") : null,
      });

      if (
        duplicatesData.status === "success" &&
        duplicatesData.data.matches.length > 0
      ) {
        setDuplicates(duplicatesData.data.matches);
        setShowDialog(true);
      }
    } catch (error) {
      console.error("Error checking duplicates:", error);
      notify("An error occurred while checking for duplicates.", {
        type: "error",
      });
    }
  };

  const [params] = useSearchParams();
  const queryParams = Object.fromEntries(params.entries());
  const reg = queryParams.registration || "";
  const number = queryParams.number || "";
  const dialled = queryParams.dialled || "";

  return (
    <Create {...props}>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label="Add/Update collection zone"
      >
        {duplicates && (
          <React.Fragment>
            <DialogTitle>Duplicates found!</DialogTitle>
            <DialogContent>
              <Typography>
                We have detected one or more leads with this registration:{" "}
              </Typography>
              {duplicates.map((duplicate, i) => {
                return (
                  <Typography key={i}>
                    <Button
                      key={i}
                      variant="contained"
                      onClick={() => {
                        location.href = duplicate.url;
                      }}
                    >
                      View lead {duplicate.primary === true ? "(Primary)" : ""}{" "}
                      {duplicate.id}
                    </Button>
                  </Typography>
                );
              })}
            </DialogContent>
            <DialogActions>
              <Button label="ra.action.cancel" onClick={handleCloseClick}>
                <Cancel />
              </Button>
            </DialogActions>
          </React.Fragment>
        )}
      </Dialog>
      <Form onSubmit={handleSubmit}>
        <React.Fragment>
          <Grid
            container
            spacing={3}
            style={{
              padding: "1rem",
            }}
          >
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              <h3
                style={{
                  margin: "0",
                }}
              >
                Create a new lead
              </h3>
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12}>
                  <TextInput
                    source="vin"
                    defaultValue={reg}
                    value={reg}
                    onBlur={(e) => handleDuplicateCheck("vin", e.target.value)}
                    name="vin"
                  />
                </Grid>
                <hr />
                <Grid item xs={12}>
                  <Stack direction="row" spacing={2}>
                    <TextInput
                      source="plate"
                      defaultValue={reg}
                      value={reg}
                      onBlur={(e) =>
                        handleDuplicateCheck("plate", e.target.value)
                      }
                      name="plate"
                      sx={{ flex: 3 }}
                    />
                    <SelectInput
                      source="state"
                      label="Select State"
                      choices={stateAbbreviations}
                      optionText="label"
                      optionValue="value"
                      sx={{ flex: 1 }}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <TextInput source="zipcode" required name="zipcode" />
                  <TextInput
                    source="number"
                    defaultValue={number}
                    value={number}
                    name="number"
                    sx={{
                      display: "none !important",
                    }}
                  />
                  <TextInput
                    source="dialled"
                    defaultValue={dialled}
                    name="dialled"
                    hidden={true}
                    sx={{
                      display: "none !important",
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              <Button
                type="submit"
                variant="contained"
                startIcon={
                  isLoading ? <CircularProgress size={16} /> : <Save />
                }
                disabled={isLoading}
                label="Save"
              />
            </Grid>
          </Grid>
        </React.Fragment>
      </Form>
    </Create>
  );
};

CreateQuoteRequest.propTypes = {
  location: PropTypes.object,
};

export default CreateQuoteRequest;
